import React, { ReactElement, Suspense, useContext } from 'react';
import { Button, Tabs, Tooltip } from 'antd';
import CcxComponentProps from '../../core/CcxComponent';
import styles from './Projects.module.less';
import { Link, useHistory, useParams } from 'react-router-dom';
import LazyLoader from '../LazyLoader';
import DataStores from './dataStores/DataStores';
import Vpcs from './vpcs/Vpcs';
import CreateVpcButton from '../vpc/CreateVpcButton';
import { DeploymentsContext } from '../../core/context/DeploymentsContext';
import { UserContext } from '../../core/context/UserContext';
import { vpcDisabled } from '../../core/CcxEnv';
import { userReachedDatastoreLimit } from '../layout/AppCreateButton';

interface UrlProps {
    projectUuid: string;
    activeTab: string;
}

interface Props extends CcxComponentProps {}

function Projects({ testId = 'Projects' }: Props): ReactElement {
    let history = useHistory();
    let { projectUuid, activeTab } = useParams<UrlProps>();
    const deploymentContext = useContext(DeploymentsContext);
    const { user: userContext } = useContext(UserContext);

    const limitReached = userReachedDatastoreLimit(
        deploymentContext,
        userContext
    );
    const operations =
        activeTab === 'data-stores' ? (
            <Tooltip title={limitReached ? userContext?.disabledText : ''}>
                <Link to={`/projects/${projectUuid}/${activeTab}/add`}>
                    <Button
                        data-testid={`${testId}CreateNewButton`}
                        type="primary"
                        disabled={limitReached}
                        className={styles.ProjectsOperationButton}
                    >
                        + Create{' '}
                        {activeTab === 'data-stores' ? 'datastore' : 'VPC'}
                    </Button>
                </Link>
            </Tooltip>
        ) : (
            <CreateVpcButton
                buttonText="+ Create VPC"
                buttonType="primary"
                className={styles.ProjectsOperationButton}
                size="middle"
            />
        );

    return (
        <section className={styles.Projects} data-testid={testId}>
            <Tabs
                className={styles.ProjectsTabs}
                data-testid={`${testId}Tabs`}
                tabBarExtraContent={operations}
                type="card"
                defaultActiveKey={activeTab}
                onChange={(tabKey: any) => {
                    history.push(`/projects/${projectUuid}/${tabKey}`);
                }}
            >
                <Tabs.TabPane tab="Datastores" key="data-stores">
                    <Suspense fallback={<LazyLoader />}>
                        <DataStores />
                    </Suspense>
                </Tabs.TabPane>

                {!vpcDisabled && (
                    <Tabs.TabPane tab="VPCs" key="vpcs">
                        <Suspense fallback={<LazyLoader />}>
                            <Vpcs />
                        </Suspense>
                    </Tabs.TabPane>
                )}
            </Tabs>
        </section>
    );
}

export default Projects;
